module.exports = __webpack_public_path__ + "img/giveProudly-log.122aaac5.svg";